// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1zCo1","error":"Textarea_error__3cuYh","readonly":"Textarea_readonly__3Y7aY","disabled":"Textarea_disabled__JzpUH"};